module.exports = __webpack_public_path__ + "62c4b2d895c74327bd885fe3f4b631a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/fan-favourite.png
// module id = up2o
// module chunks = 0